/*
 * Where to take a person after their first login when an invitation brought them to sign-up.
 * Signing up ends with an activation email, which usually opens in another tab, so the page is
 * kept in localStorage (sessionStorage would not survive the new tab).
 */
const STORAGE_KEY = "postLoginRedirect";

/** @returns {boolean} true for a path inside this app; anything else is never followed */
export const isAppPath = (path) =>
  typeof path === "string" && path.startsWith("/") && !path.startsWith("//") && !path.includes("\\");

export const rememberPostLoginRedirect = (path) => {
  if (isAppPath(path)) localStorage.setItem(STORAGE_KEY, path);
};

/** @returns {string} the remembered page, or ""; it is forgotten once read */
export const takePostLoginRedirect = () => {
  const path = localStorage.getItem(STORAGE_KEY) || "";
  localStorage.removeItem(STORAGE_KEY);
  return isAppPath(path) ? path : "";
};
